<myre-multi-table
  #table
  [columns]="_columns()"
  [tables]="_table()"
  [hover]="clickable()"
  [filterStatus]="filterStatus()"
  [headerActionButton]="actionsForSelectedRow()"
  [canSelectRows]="!!actionsForSelectedRow()"
  [sortCallback]="sortCallback()"
  [stripedRow]="false"
  [widthInPixel]="widthInPixel()"
  theme="list"
  (rowSelectionChange)="rowSelectionChange.emit($event)"
  (sortChange)="sortChange.emit($event)"
>
  @if (_filterResultTemplate()) {
    <ng-template [mTemplate]="'banner'">
      <ng-container *ngTemplateOutlet="_filterResultTemplate().template" />
    </ng-template>
  }
</myre-multi-table>

@if (_displayPagination() !== null) {
  <span class="paginator">
    <myre-paginator
      [currentPage]="_displayPagination().currentPage"
      [totalPage]="_displayPagination().totalPages"
      (onPaginate)="_handlePagination($event)"
    />
  </span>
}
